/** Pixel gap between the cursor and the top-left corner of the loupe. */
export const LOUPE_CURSOR_OFFSET = 24;

export const MAGNIFIER_LOUPE_ROLE = 'magnifier-loupe';
